import React, { memo, forwardRef } from 'react';
import classNames from 'classnames';
import { Oval } from 'react-loader-spinner';
import { Colors } from 'modules/theme';
import styles from './Button.module.scss';

// eslint-disable-next-line react/display-name
const Button = forwardRef(
  (
    {
      primary,
      secondary,
      header,
      dark,
      light,
      gray,
      disabled,
      className,
      loading,
      children,
      loaderSize = 20,
      small,
      ...otherProps
    },
    ref,
  ) => {
    const classes = classNames(
      styles.btn,
      primary && styles['btn--primary'],
      secondary && styles['btn--secondary'],
      disabled && styles['btn--disabled'],
      header && styles['btn--header'],
      small && styles['btn--small'],
      dark && styles['btn--dark'],
      light && styles['btn--light'],
      gray && styles['btn--gray'],
      className,
    );

    const loaderColor = secondary ? Colors.darkBlue : Colors.white;
    const showChildren = !loading;

    return (
      <button
        ref={ref}
        type="button"
        disabled={disabled || loading}
        className={classes}
        {...otherProps}
      >
        {loading && (
          <div className={styles.loader}>
            <Oval
              secondaryColor={loaderColor}
              color={loaderColor}
              width={loaderSize}
              height={loaderSize}
            />
          </div>
        )}
        {showChildren && children}
      </button>
    );
  },
);

export default memo(Button);
